var _effectorFileName = "/builds/gmini/front-ui-kit/src/Dialog/Dialog.styled.tsx";
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogWrapper = styled.div`
  ${props => props.scroll === 'body' ? 'overflow-x:hidden; overflow-y:auto; text-align:center;' : 'display:flex; align-items:center; justify-content:center;'}
  ${props => props.scroll === 'body' ? `&::after{
    width: 0;
    height: 100%;
    content: "";
    display: inline-block;
    vertical-align: middle;
}` : ''}
height:100%;
  outline: 0;
`;
export const PaperWrapper = styled(({
  className,
  PaperComponent,
  children
}) => /*#__PURE__*/_jsx(PaperComponent, {
  role: "dialog",
  className: className,
  elevation: 24,
  children: children
}))`
  margin: 32px;
  position: relative;
  overflow-y: auto;
  ${props => props.scroll === 'body' ? 'display: inline-block;text-align: left;vertical-align: middle;' : 'display: flex;max-height: calc(100% - 64px);flex-direction: column;'};
  max-width: ${props => {
  switch (props.maxWidth) {
    case 'xs':
      return '444px';

    case 'sm':
      return '600px';

    case 'md':
      return '960px';

    case 'lg':
      return '1280px';

    case 'xl':
      return '1920px';

    case false:
      return 'none';
  }
}};
  ${props => props.fullWidth ? 'width:calc(100% - 64px);' : ''}
`;
export const DialogRoot = styled.div`
  position: fixed;
  z-index: 1300;
  inset: 0px;
`;